export default "__VITE_ASSET__D4ps0loB__"